import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/fp/map';
import isEmpty from 'lodash/isEmpty';

import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import {translateStatus} from '../Tables/utils';
import useStyles from './styles';

function Input({onChange, options, value, ...rest}) {

  const classes = useStyles();

  const _onChange = event => {
    onChange({target: {
      id: 'status',
      name: 'status',
      value: event.target.value
    }})
  }

  const optionList = map(
    el => <MenuItem key={el} value={el}>
      {translateStatus(el)}
    </MenuItem>
  );

  return (
    <TextField
      id='status'
      name='status'
      label='Status'
      placeholder='Status'
      autoComplete='off'
      className={classes.formControl}
      onChange={_onChange}
      InputLabelProps={{
        shrink: !isEmpty(value)
      }}
      select
      value={value}
      {...rest}
    >
      {optionList(options)}
    </TextField>
  );
}

Input.propTypes = {
  onChange: PropTypes.func,
  required: PropTypes.bool
};

export default Input;
